import { BaseContextType, SchemaModelType } from '@smx-ui-model/types';
import dayjs from 'dayjs';
import { DateTime } from 'luxon';

import { getDrawingSetVersionListQuery } from '../graphql/query/get-drawing-set-version-list-query';
import { getDrawingSetVersionQuery } from '../graphql/query/get-drawing-set-version-query';
import { getDrawingSetVersionTableQuery } from '../graphql/query/get-drawing-set-version-table-query';
import schema from '../schema-generated.json';
import { DrawingSetVersionModelSchemaType, DrawingSetVersionModelType } from './types';

export const drawingSetVersionCoreModel: DrawingSetVersionModelSchemaType<BaseContextType> = {
    label: 'Drawing Set',
    name: 'drawingSetVersion',
    query: getDrawingSetVersionTableQuery,
    queryList: getDrawingSetVersionListQuery,
    queryOne: getDrawingSetVersionQuery,
    context: {
        inspectorInput: ['fileName', 'versionDate'],
    },
    schema: schema.DrawingSetVersion as unknown as SchemaModelType<DrawingSetVersionModelType>,
    isCheckBoxColumn: true,
    defaultData: {
        versionDate: () => dayjs(DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss')),
    },
};
